import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { LOYALTY_PAGE_URL } from '~/components/LoyaltyMenuItem/constants';
import { useMounted } from '~/hooks/useMounted';
import { userStore } from '~/stores';

type LoyaltyChipProps = {
  className?: string;
};

const LoyaltyChip: React.FC<LoyaltyChipProps> = observer(({ className }) => {
  const mounted = useMounted();

  if (!mounted) return null;
  if (!company.showHeaderLoyaltyChip) return null;
  if (!userStore.isAuthorized) return null;
  if (!userStore.loyaltyPointsStore.showLoyaltyPointsOnFrontend) return null;

  const balance = userStore.loyaltyPointsStore.loyaltyPoints;

  return (
    <Link
      to={LOYALTY_PAGE_URL}
      data-link="header-loyalty-chip"
      className={cn(
        'inline-flex h-12 items-center gap-2 rounded-5 bg-navigation-surface px-4 py-2 text-navigation-text-primary transition-colors duration-[256ms] ease-main hover:bg-navigation-surface-2',
        className,
      )}
    >
      <Icon type="coins-3.1" size={24} />
      <Typography.Text200Medium as="span">{balance}</Typography.Text200Medium>
    </Link>
  );
});
LoyaltyChip.displayName = 'LoyaltyChip';

export { LoyaltyChip };
